import { useState } from "react";
import { Button } from "V2.0/common/button";
import { Dialog, DialogTitle, DialogActions } from "V2.0/common/dialog";
import { showErrorToast } from "V2.0/utils";

import { message } from "antd";

interface PipelineDeleteProps {
  onPipelineDelete: (pipelineId: string, lifecycleCbs) => void;
  onClose: () => void;
  pipeline: any;
}

function PipelineDelete(props: PipelineDeleteProps) {
  const { onPipelineDelete, onClose, pipeline } = props;

  const [loading, setLoading] = useState(false);

  const handlePipelineDelete = () => {
    const lifecycleCbs = {
      init() {
        setLoading(true);
        message.loading("Deleting Pipeline");
      },
      success() {
        setLoading(false);
        message.destroy();
        message.success("Pipeline deleted");
        onClose();
      },
      error(e) {
        setLoading(false);
        message.destroy();
        showErrorToast(e, "Failed to delete pipeline");
      },
    };

    onPipelineDelete(pipeline._id, lifecycleCbs);
  };

  return (
    <Dialog
      open={true}
      onClose={onClose}
    >
      <DialogTitle>Delete {pipeline?.name}?</DialogTitle>
      <DialogActions>
        <Button
          outline
          onClick={onClose}
        >
          Cancel
        </Button>
        <Button
          onClick={handlePipelineDelete}
          loading={loading}
          disabled={loading}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PipelineDelete;
